export default {
      id: "application-outline-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#application-outline-usage",
      toString: function () {
        return this.url;
      }
    }